<template>
    <div v-show="show">
      <FilterRaceEthnicity />
      <FilterCountryOfOrigin/>
    </div>
</template>
  
<script setup>
  
  const model = useFCPModel()
    const { filterContext, races, origins, networkId, context } = useFCPModel()
    const { loadRaceEthnicity } = useApi()
    const socialDistinctions = ref([])
    const ethnicities = ref([])
    const show = computed(() => filterContext.value.type === 'doctor' || filterContext.value.type === 'dentist')

    //Race, Ethinicity, and Country of Origin are provided by the same API endpoint
    const loadSocialDistinctions = async () => {
        const result = await loadRaceEthnicity(networkId.value, context.value)
        socialDistinctions.value = result
        races.value = socialDistinctions.value.racialDistinctions
        ethnicities.value = socialDistinctions.value.ethnicDistinctions

        if (ethnicities.value.length) {
            /**
             * find the one with id=1, merge it to race list and sort the result
             * {"id": "1", "description": "Hispanic or Latino", "type": "E"}
             */
            const theEthnic = ethnicities.value.find((ethnic) => ethnic.id === '1')
                if (theEthnic) {
                    races.value.push(theEthnic)
                }
                races.value.sort((a, b) => {
                    if (a.description > b.description) return 1
                    if (a.description < b.description) return -1
                return 0
            })
        }

        //Country of Origin
        origins.value = socialDistinctions.value.originDistinctions
    }

    // need to update the social distinctions based on the networkID
    watch(networkId, () => {
        loadSocialDistinctions()
    })

    onBeforeMount(() => {
        loadSocialDistinctions()
    })
  
  </script>
  